<template>
  <v-dialog
    v-model="valueProxy"
    width="60%"
    :max-width="maxWidth"
    @create="reload"
    @update="reload"
    @delete="reload"
  >
    <ValidationObserver ref="form" v-slot="{ valid }">
      <v-card min-height="250">
        <v-card-title>
          <span class="mainTitle" style="font-size: 20px">
            {{ title }}
          </span>
          <v-spacer />
          <v-btn icon @click="valueProxy = false">
            <v-icon> mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-row>
              <v-col cols="12" md="6">
                <custom-label item-field-name="Name" />
                <ValidationProvider v-slot="{ errors }" name="Name" rules="required">
                  <v-text-field
                    outlined
                    v-model="model.name"
                    :error="!!errors.length"
                    :error-messages="errors"
                  />
                </ValidationProvider>
              </v-col>
              <v-col cols="12" md="6">
                <custom-label item-field-name="Phone" />
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Phone"
                  :rules="isAdmin || isCashier ? { digits: 8 } : { required: true, digits: 8 }"
                >
                  <v-text-field
                    autocomplete="new-password"
                    outlined
                    v-model="phone"
                    type="phone"
                    :error="!!errors.length"
                    :error-messages="errors"
                  />
                </ValidationProvider>
              </v-col>
              <v-col v-if="isAdmin || isCashier" cols="12" md="6">
                <custom-label item-field-name="Password" />
                <ValidationProvider v-slot="{ errors }" name="Password" rules="required">
                  <v-text-field
                    autocomplete="new-password"
                    v-model="model.pw"
                    :error="!!errors.length"
                    :error-messages="errors"
                    outlined
                    type="password"
                  />
                </ValidationProvider>
              </v-col>
              <v-col cols="12" md="6" v-if="isMaster">
                <custom-label item-field-name="Servicing Capacity" />
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Servicing Capacity"
                  :rules="{ required: true, min_value: 0 }"
                >
                  <v-text-field
                    outlined
                    v-model="model.servicingCapacity"
                    type="number"
                    :min="0"
                    :error="!!errors.length"
                    :error-messages="errors"
                  />
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <!--          <v-btn @click="doClose()">Close</v-btn>-->
          <v-btn color="primary" :disabled="!valid" @click="promptCreate()" v-if="isCreate">
            Create
          </v-btn>
          <v-btn color="primary" :disabled="valid" @click="promptUpdate()" v-if="!isCreate">
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import api from '@/api';
import ApiError from '@/api/ApiError';
import { createUser } from '@/api/auth/membership';
import editDialogMixin from '@/services/editDialogMixin';
import { cloneDeep } from 'lodash';
import CustomLabel from '../customFormLabel/customLabel';

export default {
  name: 'IdentityEditDialog',
  components: { CustomLabel },
  mixins: [editDialogMixin],
  props: {
    maxWidth: {
      type: String,
      default: '100vw',
    },
    roleList: {
      type: Array,
      default: () => [],
    },
    title: { default: 'Profile' },
    role: {
      type: String,
      default: 'customer',
    },
  },
  computed: {
    crudURL() {
      return `Profiles${this.id ? '/' + this.id : ''}`;
    },
    isMaster() {
      return this.role === 'bn.master';
    },
    isAdmin() {
      return this.role === 'admin';
    },
    isCashier() {
      return this.role === 'bn.cashier';
    },
    phone: {
      get() {
        return this.model.phone ? this.model.phone.replace('+852', '') : null;
      },
      set(v) {
        if (v) {
          this.$set(this.model, 'phone', '+852' + v);
        }
      },
    },
  },
  async mounted() {
    await this.reload();
  },
  methods: {
    async reload() {
      this.model = {};
    },
    async promptCreate() {
      if (!(await this.$refs.form?.validate?.())) {
        return;
      }
      try {
        let payload = cloneDeep(this.model);
        payload.role = this.role;
        // if (this.role === 'customer') {
        //   payload.enabled = false;
        // }
        if (this.isAdmin || this.isMaster || this.isCashier) {
          payload.username = this.model.name;
        }
        const model = (await createUser(api, payload)).data;
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: 'Created',
          type: 'success',
          color: 'success',
        });
        this.$emit('create', model);
        return model;
      } catch (err) {
        this.handleError(err);
      }
    },
    handleError(err) {
      const ae = ApiError.wrap(err);
      // if (ae.code === 'duplicate_key') {
      //   this.$refs.sid.applyResult({
      //     valid: false,
      //     errors: [this.$t('d.sid_was_taken')],
      //   });
      //   return;
      // }
      // alert(ae.message);
      this.$store.dispatch('alert/updateAlertMessage', {
        msg: ae.message,
      });
    },
  },
};
</script>
